module.exports = __webpack_public_path__ + "static/dog-illustration-d0e0c33403de4c5562aee18ce1352235.svg";